<template>
  <div class="client-service__main">
    <!-- Type -->
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <template v-show="!isLoading">
      <div v-if="salonServices && salonServices.length" class="client-service-type" :class="{'is-hidden': isActiveType}">
        <OneType
          v-for="(service) in salonServices"
          :category="service.category"
          :service_amout="services && services.length"
          :key="service.id"
          @click.native="onTypeClick(service)"
        ></OneType>
      </div>
      <div v-else style="padding: 10px;">Нет доступных мастеров</div>
    </template>
    <!-- Subtype -->
    <div v-show="type && type.isActive"
         class="client-service-subtype"
         :class="{'is-active': type.isActive}">
      <div class="client-service-subtype__header">
        <i class="material-icons" @click="onBack('type')">chevron_left</i>
        <div class="client-service-subtype__title-wrap">
          <h3 class="client-service-subtype__title">{{ type.category }}</h3>
          <!--<div class="client-service-subtype__amount">-->
          <!--2-->
          <!--<span></span> услуг-->
          <!--</div>-->
        </div>
        <button class="client-service-subtype__btn" type="button" @click="onBack('type')">
          Назад
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="client-service-subtype__main">
        <OneSubtype
          v-for="(subService, index) in subServices"
          :subcat_name="subService.category"
          :subcat_id="subService.id"
          :subcat_index="index"
          :subcat_amout="subService.subcat && subService.subcat.length"
          @click.native="onSubTypeClick(subService)"
          :key="index"
        ></OneSubtype>
      </div>
    </div>
    <!-- One service -->
    <div v-show="subType && subType.isActive"
         class="client-one-service"
         :class="{'is-active': subType.isActive, 'last-is-open': (hasParameters && (currentOptions && currentOptions.length)) ||
         (service.levels && service.levels.length === 0 && currentConcreteService && currentConcreteService.options && currentConcreteService.options.length > 0)}">
      <div class="client-one-service__main-info">
        <div class="client-one-service__header">
          <i @click="onBack('subType')" class="material-icons">chevron_left</i>
          <h3 class="client-one-service__title">{{ subType.category }}</h3>
          <button
            class="client-one-service__btn js-close-one"
            type="button"
            @click="onBack('subType')"
          >
            Скрыть
            <i class="material-icons">chevron_left</i>
          </button>
        </div>
        <div class="client-one-service__thead">
          <h4 class="client-one-service__head client-one-service__head--name">Наименование</h4>
          <!-- <h4 class="client-one-service__head client-one-service__head--standart">Стандарт</h4>
          <h4 class="client-one-service__head client-one-service__head--business">Бизнес</h4>
          <h4 class="client-one-service__head clien t-one-service__head--vip">Vip</h4>-->
        </div>
        <div class="client-one-service__tbody">
          <template v-if="concreteServices && concreteServices.length > 0">
            <OneService
              v-for="(service, index) in concreteServices"
              :key="service.id"
              :service_name="service.name"
              :service_price="service.price"
              :service_id="service.id"
              :service_dur="service.duration"
              :service_index="index"
              :params_lenght="service.options && service.options.length"
              :service="service"
              @click="onServiceClick(service)"
              @onSetSubServiceLevel="setSubServiceLevelId"
              ref="oneServiceChild"
            ></OneService>
          </template>
          <div v-else>Нет доступных услуг</div>
        </div>
      </div>
      <!-- Parametrs -->


      <div class="client-one-parametrs"
           v-if="currentOptions && currentOptions.length"
           :class="{'is-active': currentOptions && currentOptions.length > 0 && subServiceLevelId ||
           (service.levels && service.levels.length === 0 && currentConcreteService && currentConcreteService.options && currentConcreteService.options.length > 0)}"
      >
        <div class="client-one-parametrs__title-wrap">
          <i class="material-icons" @click="onBack()">chevron_left</i>
          <h3 class="client-one-parametrs__title">{{ service.category }}</h3>
          <button class="client-one-service__btn js-close-params" type="button" @click="onBack()">
            Скрыть
            <i class="material-icons">chevron_left</i>
          </button>
        </div>
        <div class="client-one-parametrs__block-wrap">
          <div class="client-one-parametrs__block">
            <h4 class="client-one-parametrs__subtitle">Дополнительные опции</h4>
            <!--<ParamService v-for="(option, index) in currentConcreteServiceOptions"-->
            <!--:param_name="option.name"-->
            <!--:param_price="option.price"-->
            <!--:param_id="option.id"-->
            <!--:param_index="index"-->
            <!--:key="index"-->
            <!--&gt;</ParamService>-->
            <div class="client-one-parametrs__tbody">
              <div
                class="client-one-parametrs__inputs"
                v-for="option in currentOptions"
                :key="option.id"
              >
                <input
                  type="checkbox"
                  :id="'parametr'+option.id"
                  name="client-one-service__level-options"
                  :disabled="((selectedOptionsIds.length === 4) && !isChecked(option.id))"
                  @change="inCheckedGroups(option)"
                  :value="option.id"
                />
                <label
                  :for="'parametr'+option.id"
                  class="client-one-parametrs__label client-one-parametrs__label--check"
                  :class="{checked: selectedOptionsIds.includes(option.id)}"
                >{{option.name}}, + {{option.price - 0}}₽</label>
              </div>
            </div>
          </div>
        </div>
        <div class="client-one-service__summary">
          <label class="summary-label">Сумма</label>
          <span class="summary-amount">{{totalAmount}} ₽</span>
        </div>
        <div class="client-one-service__btns">
          <button
            class="client-one-service__cancel"
            type="button"
            @click="setConcreteServiceId(null)"
          >Отменить</button>
          <router-link
            :to="`/company/${cid}/${sid}/client-masters`"
            class="client-one-service__next"
            @click.native="handleNext"
            :disabled="disabled"
          >Дальше</router-link>
        </div>
      </div>
      <!-- Next or cancel -->
      <div class="client-one-service__btns" :class="[!(currentOptions && currentOptions.length) ? 'is-active' : '']">
        <button
          v-if="disabled"
          class="client-one-service__cancel"
          type="button"
          @click="onBack('subType')"
        >Назад</button>
        <button
          v-if="!disabled"
          class="client-one-service__cancel"
          type="button"
          @click="setConcreteServiceId(null)"
        >Отменить</button>
        <router-link
          v-if="!disabled"
          :to="`/company/${cid}/${sid}/client-masters`"
          class="client-one-service__next"
          @click.native="handleNext"
          :disabled="disabled"
        >Дальше</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import OneType from "@/components/OneType/OneType.vue";
import OneSubtype from "@/components/OneSubtype/OneSubtype.vue";
import OneService from "@/components/OneService/OneService.vue";
// import ParamService from '@/components/ParamsService/ParamService.vue'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "ServiceTypes",
  components: {
    OneType,
    OneSubtype,
    OneService,
    Loading
    // ParamService
  },
  props: ['type', 'subType', 'service', 'subService', 'cid', 'sid'],
  data() {
    return {
      serviceId: "",
      subServiceId: "",
      subServiceLevelId: "",
      concreteServiceId: "",
      selectedOptionsIds: [],
      fullPage: false,
      isActiveType: false,
      isActiveSubType: false,
      isActiveService: false,
      isActiveSubService: false,
      hasParameters: false
    };
  },
  methods: {
    ...mapMutations("client", ["setServiceInProgressData"]),

    handleNext() {
      const { serviceId, subServiceId, concreteServiceId } = this;
      this.setServiceInProgressData({
        serviceId,
        subServiceId,
        concreteServiceId,
        optionsIds: this.selectedOptionsIds
      });
    },
    onBack (type) {
      this.hasParameters = false;
      if(type === 'type') {
        this.$emit('onTypeClick', {name: 'type', obj: {id: null, isActive: this.isActiveType = false}})
        this.serviceId = "";
        this.subServiceId = "";
        this.subServiceLevelId = "";
        this.concreteServiceId = "";
        this.selectedOptionsIds = [];
      }
      if (type === 'subType') this.setConcreteServiceId({id: null});

      if (type === 'type' || type === 'subType')
        this.$emit('onSubTypeClick', {name: 'subType', obj: {id: null, isActive: this.isActiveSubType = false}})

      this.$emit('onServiceClick', {name: 'service', obj: {id: null, isActive: this.isActiveService = false}})
    },
    onTypeClick(service) {
      this.serviceId = service.id;
      this.$emit('onTypeClick', {name: 'type', obj: {...service, isActive: this.isActiveType = true}})
    },
    onSubTypeClick(service) {
      this.subServiceId = service.id;
      this.$emit('onSubTypeClick', {name: 'subType', obj: {...service, isActive: this.isActiveSubType = true}})
    },
    onServiceClick (service, fromLevel) {
      this.setConcreteServiceId(service.id);
      this.subServiceLevelId = null;
      const isActive = !(service.levels && service.levels.length) ? this.isActiveService = true : !!fromLevel;
      this.$emit('onServiceClick', {name: 'service', obj: {...service, isActive}})
    },
    setSubServiceLevelId(id) {
      this.onServiceClick(this.service, true)
      this.subServiceLevelId = id;
      this.hasParameters = true;
    },
    setConcreteServiceId(id) {
      if (!id) {
        this.$refs.oneServiceChild.map(el => el.uncheckedRadio());
        this.onBack();
      } else {
        this.concreteServiceId = id;
        this.selectedOptionsIds = [];
      }

    },
    isChecked (id) {
      return this.selectedOptionsIds.find(o => id === o)
    },
    inCheckedGroups(option) {
      if(this.selectedOptionsIds.includes(option.id))
        return this.selectedOptionsIds = this.selectedOptionsIds.filter(o => o !== option.id);
      if(option.group_name !== null) {
        let gpnIds = this.currentOptions.filter(o => o.group_name === option.group_name).map(o => o.id);
        let includes = !!gpnIds.find(id => this.selectedOptionsIds.includes(id));
        if (includes && !this.selectedOptionsIds.includes(option.id))
          this.selectedOptionsIds = this.selectedOptionsIds.filter(id => !gpnIds.includes(id));
      }
      this.selectedOptionsIds.push(option.id)
    }
  },
  computed: {
    ...mapGetters("salons", [
      "getSalonServices",
      "getService",
      "getSubService",
      "getConcreteService"
    ]),
    ...mapState("client", [
      "currentSalonId",
      "customer",
      "companyId"
    ]),
    ...mapState("salons", ["services"]),
    disabled() {
      return !(this.service && this.service.id) ||
        (this.service && (this.service.levels && this.service.levels.length > 0 && !this.subServiceLevelId))
    },
    totalAmount() {
      if (this.currentConcreteService) {
        const service_price = this.currentConcreteService ? this.currentConcreteService.price : 0;
        // we using map-reduce here because someday it become to possible to choose several options.
        const options_price = this.currentOptions
          .filter(option => this.selectedOptionsIds.includes(option.id))
          .map(option => option.price - 0).reduce((a, b) => a + b, 0);
        return options_price + service_price;
      }
      return 0;
    },
    salonServices() {
      return this.getSalonServices(this.currentSalonId);
    },
    currentService() {
      return this.getService(this.currentSalonId, this.serviceId);
    },
    subServices() {
      let temp = [];

      if (this.currentService) {
        if (this.currentService.services && this.currentService.subcat.length === 0) {
          temp = [{ category: "Все услуги", subcat: [], id: -1 }];
        } else {
          temp = this.currentService.subcat.filter(e => e != null);
        }
      }
      return temp;
    },
    currentSubService() {
      return this.getSubService(
        this.currentSalonId,
        this.serviceId,
        this.subServiceId
      );
    },
    filteredOptions () {
      return this.service.levels.find(e => e.id === this.subServiceLevelId)
        ? this.service.levels.find(e => e.id === this.subServiceLevelId).options : [];
    },
    currentOptions () {
      return (this.service && this.service.options && this.currentConcreteServiceOptions)
        ? [...this.service.options, ...this.filteredOptions] : []
    },
    concreteServices() {
      return this.currentSubService
        ? this.currentSubService.services
        : [];
    },
    currentConcreteService() {
      return this.getConcreteService(
        this.currentSalonId,
        this.serviceId,
        this.subServiceId,
        this.concreteServiceId,
        this.subServiceLevelId
      );
    },
    currentConcreteServiceOptions() {
      return this.currentConcreteService ? this.currentConcreteService.options : [];
    },
    isLoading() {
      return this.salonServices === undefined;
    }
  }
};
</script>
